export default __webpack_public_path__ + "static/media/step-01.d5d59ae1.svg";